import React from "react";
import { useNavigate } from "react-router-dom";

export default function PaymentPage() {
  const navigate = useNavigate();
  const paypalPaymentUrl = "https://www.paypal.com/ncp/payment/BJXLME3RYLPCQ";

  return (
    <>
      <div style={{ height: 72 }} /> {/* Spacer for sticky header */}
      
      <div className="container py-5" style={{ maxWidth: 900 }}>
        {/* Trust Header */}
        <div className="text-center mb-4">
          <div className="d-flex justify-content-center align-items-center gap-3 mb-3">
            <i className="bi bi-shield-check-fill" style={{ fontSize: "2.5rem", color: "#28a745" }}></i>
            <h1 className="fw-bold mb-0" style={{ color: "#2e3d9c", fontFamily: "'Poppins', sans-serif" }}>
              Secure Payment Portal
            </h1>
          </div>
          <p className="text-muted fs-5">
            Make secure payments via PayPal - Fast, Safe, and Trusted
          </p>
        </div>

        {/* Main Payment Card */}
        <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
          <div className="card-body p-4 p-md-5">
            {/* Company Branding Section */}
            <div className="text-center mb-4 pb-4 border-bottom">
              <div 
                className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #6B46C1 0%, #D53F8C 100%)",
                  color: "white",
                  fontSize: "2.5rem",
                  fontWeight: "bold"
                }}
              >
                N
              </div>
              <h2 className="fw-bold mb-2" style={{ color: "#2e3d9c", fontFamily: "'Poppins', sans-serif" }}>
                NEXEN CONSULTS LLC
              </h2>
              <p className="text-muted mb-0">
                <i className="bi bi-envelope-fill me-2"></i>
                nexenconsults@gmail.com
              </p>
            </div>

            {/* Payment Button Section */}
            <div className="text-center mb-4">
              <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                Complete Your Payment
              </h4>
              <div
                className="mx-auto p-4 bg-light rounded-4 d-inline-block"
                style={{
                  border: "3px solid #e9ecef",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
                }}
              >
                <button
                  className="btn btn-lg fw-semibold text-white px-4 py-3"
                  onClick={() => window.open(paypalPaymentUrl, "_blank", "noopener,noreferrer")}
                  style={{
                    background: "linear-gradient(90deg, #0070BA, #003087)",
                    border: "none",
                    borderRadius: "12px"
                  }}
                >
                  <i className="bi bi-paypal me-2"></i>
                  Pay Securely with PayPal
                </button>
              </div>
              <p className="text-muted mt-3 small">
                Click the button above to open our secure PayPal payment page
              </p>
            </div>

            {/* Payment Instructions */}
            <div className="bg-light rounded-3 p-4 mb-4">
              <h5 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                <i className="bi bi-info-circle-fill me-2"></i>
                Payment Instructions
              </h5>
              <ol className="mb-0 ps-3">
                <li className="mb-2">Click the "Pay Securely with PayPal" button above</li>
                <li className="mb-2">You will be redirected to our official PayPal payment page</li>
                <li className="mb-2">Enter the payment amount and your billing details</li>
                <li className="mb-2">Review and confirm your payment securely</li>
                <li>Save your payment confirmation for your records</li>
              </ol>
            </div>

            {/* Security & Trust Indicators */}
            <div className="row g-3 mb-4">
              <div className="col-md-4">
                <div className="text-center p-3 bg-white rounded-3 border">
                  <i className="bi bi-shield-lock-fill d-block mb-2" style={{ fontSize: "2rem", color: "#28a745" }}></i>
                  <small className="fw-semibold d-block">SSL Secured</small>
                  <small className="text-muted">256-bit encryption</small>
                </div>
              </div>
              <div className="col-md-4">
                <div className="text-center p-3 bg-white rounded-3 border">
                  <i className="bi bi-bank d-block mb-2" style={{ fontSize: "2rem", color: "#6B46C1" }}></i>
                  <small className="fw-semibold d-block">Bank-Level Security</small>
                  <small className="text-muted">FDIC insured</small>
                </div>
              </div>
              <div className="col-md-4">
                <div className="text-center p-3 bg-white rounded-3 border">
                  <i className="bi bi-check-circle-fill d-block mb-2" style={{ fontSize: "2rem", color: "#28a745" }}></i>
                  <small className="fw-semibold d-block">Verified Business</small>
                  <small className="text-muted">Legitimate entity</small>
                </div>
              </div>
            </div>

            {/* Important Notes */}
            <div className="alert alert-info border-0 rounded-3 mb-4">
              <h6 className="fw-semibold mb-2">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                Important Information
              </h6>
              <ul className="mb-0 small">
                <li>PayPal payments are secure and encrypted</li>
                <li>Please include your invoice number or reference in the payment memo</li>
                <li>You will receive a confirmation email after payment is processed</li>
                <li>For payment verification, contact us at <strong>info@nexenconsults.com</strong></li>
              </ul>
            </div>

            {/* Contact Support */}
            <div className="text-center">
              <p className="text-muted mb-3">
                Need assistance with your payment?
              </p>
              <div className="d-flex gap-2 justify-content-center flex-wrap">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => navigate("/contact")}
                >
                  <i className="bi bi-envelope me-2"></i>
                  Contact Support
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => navigate(-1)}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* PayPal Footer */}
        <div className="text-center mt-4">
          <p className="text-muted small mb-2">Payments supported via</p>
          <div className="d-flex align-items-center justify-content-center gap-2">
            <span
              className="fw-bold"
              style={{
                fontSize: "1.5rem",
                color: "#003087",
                fontFamily: "'Poppins', sans-serif"
              }}
            >
              PayPal
            </span>
          </div>
        </div>
      </div>

      {/* Bootstrap Icons */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
      />
    </>
  );
}
